import { REQUIRED_MSG } from '../../../../../constants/service/common/formRulesConstants';
import { ValidationRule, WrappedFormUtils } from '@ant-design/compatible/lib/form/Form';
import { TimedealWidgetDetailV2 } from '../../../../../types/widget';
import { validateStringLength } from '../../../../../lib/utils/form/validators';
import { formRequiredRules } from '../../../../../lib/formRules';

type TimedealWidgetFormRuleReturnType = {
  mainTitle: { rules: ValidationRule[] };
  subTitle: { rules: ValidationRule[] };
  memo: { rules: ValidationRule[] };
  widgetItemTimeDealList: {
    rules: ValidationRule[];
    innerRules: {
      coupon: {
        hideIf: boolean;
        rules: ValidationRule[];
      };
      mobileImage: {
        rules: ValidationRule[];
      };
      pcImage: {
        rules: ValidationRule[];
      };
      memo: {
        rules: ValidationRule[];
      };
      link: {
        rules: ValidationRule[];
      };
    };
  };
};

export const useTimdealWidgetFormRules = (form: WrappedFormUtils): TimedealWidgetFormRuleReturnType => {
  const { isUseCoupon } = form.getFieldsValue(['isUseCoupon']) as Pick<TimedealWidgetDetailV2, 'isUseCoupon'>;

  return {
    mainTitle: {
      rules: [
        formRequiredRules(true, REQUIRED_MSG),
        { validator: validateStringLength({ max: 20, message: '위젯 타이틀의 글자 수는 최대 20자입니다' }) },
      ],
    },
    subTitle: {
      rules: [
        { validator: validateStringLength({ max: 20, message: '위젯 서브 타이틀의 글자 수는 최대 20자입니다.' }) },
      ],
    },
    memo: {
      rules: [{ validator: validateStringLength({ max: 1000, message: '메모는 최대 글자 수는 1,000자입니다.' }) }],
    },
    widgetItemTimeDealList: {
      rules: [{ required: true, type: 'array', message: REQUIRED_MSG }],
      innerRules: {
        coupon: {
          hideIf: !isUseCoupon,
          rules: [{ required: true, type: 'object', message: '쿠폰 ID를 반드시 설정해야 합니다' }],
        },
        mobileImage: {
          rules: [{ required: true, type: 'array', message: REQUIRED_MSG }],
        },
        pcImage: {
          rules: [{ required: true, type: 'array', message: REQUIRED_MSG }],
        },
        memo: {
          rules: [
            formRequiredRules(true, REQUIRED_MSG),
            { validator: validateStringLength({ max: 250, message: '메모는 최대 글자 수는 250자입니다.' }) },
          ],
        },
        link: {
          rules: [{ required: true, type: 'object', message: '링크 ID를 반드시 설정해야 합니다' }],
        },
      },
    },
  };
};
